import Vue from 'vue'
import ImageCompressor from 'image-compressor.js'
import logopdf from "@/assets/logo-pdf.png"
import logoword from "@/assets/logoword.png"
import logoexcel from "@/assets/logo-excel.png"
import filenuvem from "@/assets/fileupload.png"


const procImages = {
    resizeImage: async function(imagem, minWidth, minHeight) {
        
      var tamanhoReduzido = null
      try {
        tamanhoReduzido = await achaMetadeTamanhoImagem(imagem, minWidth, minHeight)
      } catch(e) {
        console.log(e)
      }

      const imageCompressor = new ImageCompressor();
      const options = { quality: .6 }
      if (tamanhoReduzido.width) options.maxWidth = tamanhoReduzido.width
      if (tamanhoReduzido.height) options.maxHeight = tamanhoReduzido.height

      try {
        const response = await imageCompressor.compress(imagem, options)
        return response
      } catch (error) {
        reject('Erro ao processar imagem')
      }
    },

    geraArquivoUpload: async function (file) {
      return new Promise(async function(resolve, reject) { 

        let extensao = file.name.split('.').pop();
        let img = { name: file.name, type: file.type, extensao: extensao, preview: null, filedata: null, tipo: 'file', size: file.size, nm_fileorig: file.name }

        if ( /\.(jpe?g|png|gif)$/i.test( file.name ) ) {

          //gerar base64 da imagem e um preview da imagem
          try {
            let reader = new FileReader();
            await reader.addEventListener("load", async function() {
              await Vue.nextTick(async function(){
                img.preview = reader.result
                img.filedata = file
                resolve(img)
              }.bind(this))
            }.bind(this), false);
            reader.readAsDataURL( file );
          } catch(e) {
            reject(`Erro ao gerar File ${file.name}`)
          }

      } else if ( /\.(pdf|doc|docx|xls|xlsx)$/i.test( file.name ) )  {

        var logo = logopdf
        if ( /\.(doc|docx)$/i.test( file.name ) ) logo = logoword
        if ( /(xls|xlsx)$/i.test( file.name ) ) logo = logoexcel

          //gerar preview com logo pdf ou word 
          try {
            let reader = new FileReader();
            reader.addEventListener("load", async function(){
              await Vue.nextTick(async function(){
                img.preview = logo
                img.filedata = file
                resolve(img)
              }.bind(this))       
            }.bind(this), false);
            reader.readAsDataURL( file );
          } catch (e) {
            reject(`Erro ao gerar File ${file.name}`)
          }

        } else { 
          //reject(`Imagem ${file.name} inválida`)

          var logo = filenuvem
          //gerar preview com logo pdf ou word 
          try {
            let reader = new FileReader();
            reader.addEventListener("load", async function(){
              await Vue.nextTick(async function(){
                img.preview = logo
                img.filedata = file
                resolve(img)
              }.bind(this))       
            }.bind(this), false);
            reader.readAsDataURL( file );
          } catch (e) {
            reject(`Erro ao gerar File ${file.name}`)
          }
        }
      })

    }

  }


const achaMetadeTamanhoImagem = (imagem, minWidth=2048, minHeight=2560) => {
  return new Promise(async function(resolve, reject) {          
    var width, height, img;
    var _URL = window.URL || window.webkitURL;
    img = new Image()
    img.onload = await function() {
      width = this.width
      height = this.height 
      if (this.width > minWidth || this.height > minHeight) {
        width = (this.width/2)
        height = (this.height/2)
      }
      resolve({width, height})
    }
    img.onerror = function() {
      reject( "Tipo de arquivo não é válido para compressão : " + imagem.type);
    }
    img.src = _URL.createObjectURL(imagem)
  })
}

export default procImages;


// WEBPACK FOOTER //
// ./src/mixins/procImages.js